import React from "react";
import { useState, useEffect } from "react";
import Pagination from "../../components/Pagination/Pagination";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";
import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import UpdateManuscriptStatus from "./UpdateManuscriptStatus";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import * as XLSX from "xlsx";


const commentReportHeader = [
  "manuscriptId",
  "curator",
  "comments",
  "commentsCount",
];

const CommentReport = (projectId) => {

    const initialFormData = {
      manuscriptId: "",
      curator: "",
      comments: "",
      commentsCount: "",
    };


     const [project, setProject] = useState("");
     const [projects, setProjects] = useState([]);
     const localStorageService = LocalStorageService.getService();
     const [formData, setformData] = useState(initialFormData)
     const [projectReport, setprojectReport] = useState([]);

  const apiService = new AxiosService();

        useEffect(() => {
            apiService
              .getProjectList()
              .then((response) => {
                console.log(response.data);
                setProjects(response.data.data);
              })
              .catch((error) => {
                toast.error(error.response.data.message, { autoClose: 3000 });
              });
          }, []);
    const handleProjectChange = (event) => {
      const projectId = event.target.value;
      setProject(projectId);
      const selectedProject = projects.find((project) => {
        if (project.projectId == projectId) {
          return project;
        }
      });
      localStorageService.setProjectDetails(
        JSON.stringify({
          projectId: projectId,
          projectName: selectedProject ? selectedProject.projectName : "",
        })
      );

      apiService
        .getCommentReport(projectId)
        .then((response) => {
          console.log("----", response.data.data);
          setprojectReport(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });

    };

    const downloadExcel = () => {
      const data = projectReport.map((item) =>
        Object.fromEntries(
          commentReportHeader.map((field) => [field, item[field]])
        )
      );

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      XLSX.writeFile(workbook, "comment_report.xlsx");
    };

return (
  <div className="container-fluid">
    <h3 className="text-center">Comment Report</h3>
    <label htmlFor="project" className="form-label">
      Project
    </label>
    <select
      className="form-select form-select-sm"
      id="project"
      name="project"
      style={{ width: "300px" }}
      onChange={handleProjectChange}
    >
      <option selected value={""}>
        Choose Project..
      </option>
      {projects &&
        projects.map((project) => (
          <option
            value={project.projectId}
            className="bg-gray-100 hover:bg-gray-200"
            key={project.projectId}
          >
            {project.projectName}
          </option>
        ))}
    </select>

    <div className="pt-3">
      {projectReport.length > 0 && (
        <div className="text-end w-75 mx-auto mt-3">
          <button className="btn btn-success btn-sm" onClick={downloadExcel}>
            Download Excel
          </button>
        </div>
      )}
      {project && (
        <table className="table table-bordered w-75 mx-auto mt-4">
          <thead>
            <tr>
              {commentReportHeader.map((header) => (
                <th
                  key={header}
                  className="bg-light text-secondary fs-6 fw-medium text-nowrap"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {projectReport.map((item, idx) => (
              <tr key={idx}>
                {commentReportHeader.map((field) => (
                  <td key={field}>
                    {typeof item[field] === "object" && item[field] !== null
                      ? JSON.stringify(item[field])
                      : item[field]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
);

};
export default CommentReport;;